export enum EmployedSincePeriod {
	MonthsLessThan1 = 'MonthsLessThan1',
	MonthsLessThan6 = 'MonthsLessThan6',
	MonthsFrom6To12 = 'MonthsFrom6To12',
	YearsFrom1To3 = 'YearsFrom1To3',
	YearsFrom3To5 = 'YearsFrom3To5',
	YearsMoreThan5 = 'YearsMoreThan5',
}
